import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../../environments/environment";
import { isNull, isNullOrUndefined } from "util";
import { AlertifyService } from "../alertify.service";

@Injectable()
export class BaseService {
  constructor(
    private http: HttpClient,
    private alertifyService: AlertifyService
  ) {}

  private API_URL = environment.API_URL;

  private createTokenOptions() {
    return {
      headers: new HttpHeaders()
        .set("Authorization", `Bearer ${localStorage.getItem("token")}`)
        .set("Access-Control-Allow-Origin", "*")
        .set("Access-Control-Allow-Methods", "GET,PUT,POST,DELETE")
        .set("Access-Control-Allow-Headers", "Content-Type"),
    };
  }

  public post<T>(end_point, item, params?: object, base_url?): Observable<T> {
    return this.http.post<T>(
      `${
        isNullOrUndefined(base_url) ? this.API_URL : base_url
      }/${end_point}${this.formUrlParam(params)}`,
      item,
      this.createTokenOptions()
    );
  }

  public update<T>(end_point, item, params?: object, base_url?): Observable<T> {
    return this.http.post<T>(
      `${isNullOrUndefined(base_url) ? this.API_URL : base_url}/${end_point}`,
      item,
      this.createTokenOptions()
    );
  }

  public get<T>(end_point, params?: object, base_url?): Observable<T> {
    return this.http.get<T>(
      `${
        isNullOrUndefined(base_url) ? this.API_URL : base_url
      }/${end_point}${this.formUrlParam(params)}`,
      this.createTokenOptions()
    );
  }

  public list<T>(end_point, params?: object, base_url?): Observable<T[]> {
    return this.http.get<T[]>(
      `${
        isNullOrUndefined(base_url) ? this.API_URL : base_url
      }/${end_point}${this.formUrlParam(params)}`,
      this.createTokenOptions()
    );
  }
  public delete(end_point, params?: object, base_url?) {
    return this.http.delete(
      `${
        isNullOrUndefined(base_url) ? this.API_URL : base_url
      }/${end_point}${this.formUrlParam(params)}`,
      this.createTokenOptions()
    );
  }

  public formUrlParam(params) {
    if (isNullOrUndefined(params)) return "";

    let queryString: string = "";
    for (const key in params) {
      if (params.hasOwnProperty(key)) {
        if (!queryString) {
          queryString = `?${key}=${params[key]}`;
        } else {
          queryString += `&${key}=${params[key]}`;
        }
      }
    }
    return queryString;
  }
}
